import { Loader } from '@googlemaps/js-api-loader';

let apiRequestJSON, 
    apiFilters,
    google,
    map;

// eslint-disable-next-line no-undef
const location = single_map.location;

// eslint-disable-next-line no-undef
const nonce = single_map.nonce;

// eslint-disable-next-line no-undef
const ajaxUrl = single_map.ajax_url;

// eslint-disable-next-line no-undef
const mapStyles = single_map.map_styles;

// eslint-disable-next-line no-undef
const mapIcon = single_map.icon;

async function initSingleMap() {
    if(!location) return;

    const singleMap = document.querySelector('#single-map');

    const {data : apiKey} = await apiRequestJSON('GET','google_api_key', apiFilters);
    const {lat, lng, zoom} = location;
    const styles = mapStyles ? JSON.parse(mapStyles) : null;

    const loader = new Loader({
        apiKey,
        version: "weekly",
    });

    loader
        .load()
        .then((googleResponse) => {
            google = googleResponse;

            map = new google.maps.Map(singleMap, {
                center: {
                  lat,lng
                },
                zoom,
                styles
            });

            setMarker(lat,lng);
        })
        .catch(e => {
            // eslint-disable-next-line no-console
            console.error(e);
        });
}

//----------------------------------------------------------
function initVariables() {
    apiRequestJSON = async (method, action, params = {}) => {
        let urlParams = `${ajaxUrl}?action=${action}&`;

        for (const key in params) {

            // eslint-disable-next-line no-prototype-builtins
            if (params.hasOwnProperty(key)) {
                urlParams+= `${key}=${params[key]}&`
            }
        }
        const response = await fetch(urlParams, {
            method,
            credentials: 'same-origin',
            headers: {
            'Content-Type': 'application/json'
            },
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

     //
     apiFilters = {
        nonce,
    }
}


function setMarker(lat, lng) {

    const iconOptions = {
        url: mapIcon,
        scaledSize: new google.maps.Size(45, 45), // scaled size
    };

    const marker = new google.maps.Marker({
        position: {
            lat,
            lng
        },
        icon: mapIcon ? iconOptions : null,
    });

    marker.setMap(map);
}


document.addEventListener( 'DOMContentLoaded', () => {
    initVariables();
    initSingleMap();
} );